if(!customElements.get('material-select')) {
  class MaterialSelect extends HTMLElement { 
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.ul = this.querySelector('ul');
      this.a = this.querySelectorAll('a');
      this.isOpen = false;
    }

    close() {
      this.classList.remove('is-open');

      window.setTimeout(() => {
        const field = this.closest('material-field');
        this.classList.toggle('is-filled', this.input.value != '');
        field.classList.toggle('has-error', this.input.value == '');
        if(this.input.value && this.input.value != '') field.removeErrorMessage();
        if(!this.input.value || this.input.value == '') field.addErrorMessage();
      }, 0);

      this.isOpen = false;
    }

    open() {
      this.classList.add('is-open');
      this.isOpen = true;
    }

    toggle(event) {
      event.preventDefault();
      event.stopPropagation();
      return this.isOpen ? this.close() : this.open();
    }

    connectedCallback() {
      this.addEventListener('click', (e) => this.toggle(e));
      document.body.addEventListener('click', (e) => this.close(e));
      
      this.a.forEach(a => {
        a.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const active = this.querySelector('.is-active');
          if(active) active.classList.remove('is-active');
          a.classList.add('is-active');
          this.input.setAttribute('value', a.dataset.value);
          this.close();
        });
      });
    }
  }

  customElements.define('material-select', MaterialSelect);
}
